<template>
  <vue-simple-table
    class="table"
    small-padding
    head-background
    bordered
    :hoverable-rows="false"
  >
    <template #colgroup>
      <col :width="`${100 - metricColWidth * columns.length}%`">
      <col
        v-for="_ of columns"
        :width="`${metricColWidth}%`"
      >
    </template>
    <template #head>
      <vue-line type="head">
        <vue-item>Тип страниц</vue-item>
        <vue-item
          v-for="(column, i) of columns"
          :key="i"
        >
          {{ column.name }}
        </vue-item>
      </vue-line>
    </template>
    <template #body>
      <vue-line
        v-for="(item, i) of items"
        :key="i"
        :class="{summary: typeof item.id === 'string' && item.id.includes('sum')}"
      >
        <vue-item>{{ item.name }}</vue-item>
        <vue-item
          v-for="column of columns"
          :key="i + column.id"
          align="right"
        >
          <div class="metric">
            <div class="metric__value">
              {{
                item[`${column.id}_one`] || item[`${column.id}_one`] === 0 ? item[`${column.id}_one`] : '-' | formatCount
              }}
              <template v-if="column.percent">%</template>
            </div>

            <vue-element
              v-if="item[`${column.id}_diff`] || item[`${column.id}_diff`] === 0"
              class="metric__diff"
              type="label"
              :data="getDiff(item, column.id)"
              :locale-options="{maximumFractionDigits: 0}"
              temperature
              label-note="%"
            />
          </div>
        </vue-item>
      </vue-line>
    </template>
  </vue-simple-table>
</template>

<script>
import {roundNumber} from '@/function'

export default {
  name: 'tableEntityDiff',

  props: {
    items: {
      type: Array,
      default: () => []
    },

    columns: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      metricColWidth: 15
    }
  },

  methods: {
    roundNumber,

    getDiff(item, metric) {
      const one = item[`${metric}_one`]
      const two = item[`${metric}_two`]
      const diff = item[`${metric}_diff`]

      return diff === undefined
        ? undefined
        : diff === 0
          ? 0
          : diff === one
            ? 100
            : roundNumber((diff * 100 / two), 0)
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  & /deep/ thead .table-item {
    background: linear-gradient(0deg, rgba(255, 255, 255, .9), rgba(255, 255, 255, .9)), #C2C9D1 !important;
    color: #455165;
  }
}

.metric {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 4px;

  &__diff._bg {
    height: 16px;
    padding: 0 4px;
    line-height: 16px;
    font-size: 12px;
  }
}

.summary {
  font-weight: 500;
}
</style>
